import { gql } from '@apollo/client';

export default class SplitAmountSettingsMutate {
    static SAVE_SPLIT_AMOUNT_BETWEEN_LOTS = gql`
        mutation saveSplitAmountBetweenLots($input: [SplitAmountBetweenLotsInput!]!) {
            saveSplitAmountBetweenLots(input: $input)
        }
    `;
}
